import workspaceQuery from 'graphql/queries/product/SupplierPriceMatrixPreviewWorkspaceQuery.graphql';
import instanceQuery from 'graphql/queries/product/PriceMatrixPreviewQuery.graphql';
import fragment from 'graphql/fragments/supplier/SupplierPriceMatrixPreviewFragment.graphql';

const SupplierPriceMatrixPreview = {
  type: 'PriceChange',
  title: 'Supplier Price Matrix Preview',
  workspaceUrl: '/Purchasing/SupplierPricing/SupplierPriceMatrix/Preview/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  fragment,
  screenReference: 'SUPPLIER_PRICE_MATRICES',
};

export default SupplierPriceMatrixPreview;
